import { connect } from 'react-redux';
import Sidebar from './Sidebar';
import {
  fetchSupplierAuthorizations,
  fetchUniqueSelectors,
  getCurrentSelection,
  getSelectorsData,
  resetSupplierAuth,
  setSelectorsListLoading,
  setSupplierAuthorizationsPending,
} from '../store/supplierAuthorizationSlice';
import { setFilters } from '../../filters/store/filtersSlice';

const mapState = state => ({
  currentSelection: getCurrentSelection(state),
  selectorsList: getSelectorsData(state),
  selectorsListLoading: state.loadingManagement.supplierAuthorizations.selectorsListLoading,
  supplierAuthorizationsPending:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsPending,
});

const mapDispatchToProps = {
  fetchSupplierAuthorizations,
  fetchUniqueSelectors,
  resetSupplierAuth,
  setFilters,
  setSelectorsListLoading,
  setSupplierAuthorizationsPending,
};

export default connect(mapState, mapDispatchToProps)(Sidebar);
